import string from '../../res/string';
import {ExclamationCircleOutlined} from "@ant-design/icons";
import color from "../../res/color";

const userTypeCode = [
  '',
  '라이더',
  '팀장',
  '본부장',
  '부본부장',
  '수석본부장',
  '부지점장',
  '지점장',
  '부센터장',
  '센터장',
];

const riderStatusCode = ['', '근무', '휴식', '퇴근'];

const paymentMethodCode = {
  none: 0,
  card: 1,
  cash: 2,
  advance: 3,
  installment: 4,
};

const paymentMethodString = ['', '카드', '현금', '선불', '분할'];

const paymentMethod = ['', '카드', '현금', '선결'];

const paymentStatus = ['', '요청', '완료', '취소', '에러', '삭제'];

const pickupTimeCode = [
  '',
  '5분',
  '10분',
  '15분',
  '20분',
  '25분',
  '30분',
  '35분',
  '40분',
  '45분',
  '50분',
  '55분',
  '60분',
  '65분',
  '70분',
  '후5분',
  '후10분',
  '후15분',
  '후20분',
  '후25분',
];
const pickupTimeValue = [
  '',
  5,
  10,
  15,
  20,
  25,
  30,
  35,
  40,
  45,
  50,
  55,
  60,
  65,
  70,
  1005,
  1010,
  1015,
  1020,
  1025,
];

const pickupTimeMap = {
  5: '5분',
  10: '10분',
  15: '15분',
  20: '20분',
  25: '25분',
  30: '30분',
  35: '35분',
  40: '40분',
  45: '45분',
  50: '50분',
  55: '55분',
  60: '60분',
  65: '65분',
  70: '70분',
  1005: '후5분',
  1010: '후10분',
  1015: '후15분',
  1020: '후20분',
  1025: '후25분',
};

const frStatusCode = {
  none: 0,
  opened: 1,
  preparing: 2,
  closed: 3,
};
const frStatusString = {
  0: '',
  1: '영업중',
  2: '준비중',
  3: '영업 종료',
};
const getFrStatusString = (code) => {
  return frStatusString[code];
};

const orderStatusCode = {
  none: 0,
  order: 1,
  assign: 2,
  pickup: 3,
  complete: 4,
  cancel: 5,
  misc: 6,
};
const orderStatusString = {
  0: 'POS',
  1: '접수', //주문
  2: '배차', //라이더 배정
  3: '픽업', //픽업 완료
  4: '배달완료',
  5: '취소', //주문 취소
  6: '기타',
};
const orderStatusStringm = {
  0: 'POS',
  1: '접수', //주문
  2: '배차', //라이더 배정
  3: '픽업', //픽업 완료
  4: '배달완료',
  5: '취소', //주문 취소
  6: '기타',
};
const getOrderStatusString = (code) => {
  return orderStatusString[code];
};
const getOrderStatusStringm = (code) => {
  return orderStatusStringm[code];
};

const packAmountCodeString = {
  1: '1개',
  2: '2개',
  3: '3개',
  4: '4개',
  5: '5개',
};

const allCategoryCode = {
  ALL: '전체',
  CASH_ORDER_PRICE_RECEIVE: '현금배달입금',
  CASH_ORDER_PRICE_RECEIVE_RESTORE: '현금배달입금반환',
  DELIVERY_PRICE_SEND: '배달비',
  DELIVERY_PRICE_SEND_RESTORE: '배달비반환',
  DUES_PAY: '가맹비',
  DUES_PAY_RESTORE: '가맹비반환',
  NCASH_CHARGE_PROC: '충전',
  NCASH_SEND: '라이더입금',
  NCASH_SEND_BY_ADMIN: string.ncashSendByAdminCodeUtil,
  WITHDRAW_REQ: '기타',
  BATCH_WORK_NCASH_MONTHLY: '월차감',
  BATCH_WORK_NCASH: '일차감',
};
const categoryCode = {
  ALL: { title: '전체', children: [] },
  CASH_ORDER_PRICE_RECEIVE: {
    title: '현금배달입금',
    children: ['CASH_ORDER_PRICE_RECEIVE_RESTORE'],
  },
  // CASH_ORDER_PRICE_RECEIVE: "현금결제분 수령",
  // CASH_ORDER_PRICE_RECEIVE_RESTORE: "현금결제분 복구",

  DELIVERY_PRICE_SEND: {
    title: '배달비',
    children: ['DELIVERY_PRICE_SEND_RESTORE'],
  },
  // DELIVERY_PRICE_SEND_RESTORE: "배달비 취소",

  DUES_PAY: { title: '가맹비', children: ['DUES_PAY_RESTORE'] },
  // DUES_PAY_RESTORE: "가맹비 반환",

  NCASH_CHARGE_PROC: { title: '충전', children: [] },

  NCASH_SEND: { title: '라이더 입금', children: [] }, // "라이더 전송",
  NCASH_SEND_BY_ADMIN: { title: string.ncashSendByAdminCodeUtil, children: [] },

  WITHDRAW_REQ: { title: '기타', children: ['BATCH_WORK_NCASH_MONTHLY'] },

  // WITHDRAW_REQ: "출금",
  // BATCH_WORK_NCASH: "일차감",
};

const deliveryCategoryCode = {
  DELIVERY_PRICE_SEND: '배달비',
  DELIVERY_PRICE_SEND_RESTORE: '배달비 취소',
};

const pointType = {
  0: '',
  1: '적립',
  2: '차감',
};

const bankCode = {
  '001': '한국은행',
  '002': '산업은행',
  '003': '기업은행',
};

const ncashChargeThresholds = [10000, 20000, 50000];

const checkDepositCharge = (ncash) => {
  for (let i = 0; i < ncashChargeThresholds.length; ++i) {
    if (ncashChargeThresholds[i] >= ncash) return i;
  }
  return -1;
};

const defaultConst = {
  paymentMethod: 3,
  pickupTime: 1,
};

const branchAddressSearchKeyword = {
  김포: ['김포', '고촌'],
  고양: ['고양', '덕양'],
  성남: ['복정'],
};

const dosiguCode = [
  '경기도',
  '경기',
  '고양시',
  '김포시',
  '덕양구',
  '일산동구',
  '일산서구',
];

const dosiguCodeReplace = (addrData) => {
  dosiguCode.forEach((data) => {
    addrData = addrData.replace(data, '');
  });
  return addrData.trim();
};

const paystoryCardCode = {
  '01': '비씨',
  '02': '국민',
  '03': '하나',
  '04': '삼성',
  '06': '신한',
  '07': '현대',
  '08': '롯데',
  11: '시티',
  12: 'NH농협',
  13: '수협',
  15: '우리',
  21: '광주',
  22: '전북',
  23: '제주',
  25: '해외비자',
  26: '해외마스터',
  27: '해외다이너스',
  28: '해외AMAX',
  29: '해외JCB',
  30: '해외',
  32: '우체국',
  33: 'MG새마을체크',
  34: '중국은행체크',
  38: '은련',
  41: '신협',
  42: '저축은행',
  43: 'KDB산업',
  44: '카카오뱅크',
  45: '케이뱅크',
  46: '카카오머니',
  47: 'SSG머니',
};

const paystoryCardType = {
  '01': '일반',
  '02': '법인',
};

const reserveOrderProcessStatusCode = {
  1: '예약',
  2: '접수',
  3: '취소',
  4: '실패',
};

const modalStyle = {
  icon: <ExclamationCircleOutlined style={{color: color.warn}}/>,
  okButtonProps: {
    className: color.okButtonClassName
  },
  cancelButtonProps: {
    className: color.cancelButtonClassName
  },
}

const modalErrorStyle = {
  okButtonProps: {
    className: color.okButtonClassName
  },
  cancelButtonProps: {
    className: color.cancelButtonClassName
  },
}

export {
  userTypeCode,
  riderStatusCode,
  paymentMethodCode,
  paymentMethodString,
  paymentMethod,
  paymentStatus,
  pickupTimeCode,
  pickupTimeValue,
  frStatusCode,
  getFrStatusString,
  orderStatusCode,
  getOrderStatusString,
  getOrderStatusStringm,
  categoryCode,
  deliveryCategoryCode,
  pointType,
  checkDepositCharge,
  packAmountCodeString,
  defaultConst,
  branchAddressSearchKeyword,
  dosiguCodeReplace,
  allCategoryCode,
  pickupTimeMap,
  paystoryCardCode,
  paystoryCardType,
  reserveOrderProcessStatusCode,
  modalStyle,
  modalErrorStyle,
};
